/* eslint-disable no-undef */
import { Amplify } from "aws-amplify";

export const configure = () => {
  Amplify.configure(
    {
      Auth: {
        Cognito: {
          region: process.env.REACT_APP_AUTH_REGION,
          userPoolId: process.env.REACT_APP_AUTH_USER_POOL_ID,
          userPoolClientId: process.env.REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID,
        },
      },
      API: {
        REST: {
          cmsAPI: {
            endpoint: process.env.REACT_APP_API_ENDPOINT,
            region: process.env.REACT_APP_AUTH_REGION,
          },
        },
      },
    },
    { ssr: false }
  );
};
